import {
    Box,
    Button,
    Card,
    Container,
    Typography,
    Alert,
    CircularProgress,
    Dialog,
    Divider,
    Chip,
    Grid,
    Paper,
    TextField,
    RadioGroup,
    Radio,
    FormControlLabel,
    FormControl,
    FormLabel,
    MenuItem,
    Link,
    InputLabel,
    Select,
    FormHelperText
  } from "@mui/material";
  import { useTheme } from "@mui/material/styles";
  import { Helmet } from "react-helmet-async";
  import { useState, useEffect } from "react";
  import { useParams } from "react-router-dom";
  import { fetchUtils } from "react-admin";
  import { BASE_API_URL } from "config/configUrl";
  import AccessTimeIcon from '@mui/icons-material/AccessTime';
  import PaymentIcon from '@mui/icons-material/Payment';
  import BusinessIcon from '@mui/icons-material/Business';
  import InfoIcon from '@mui/icons-material/Info';
  import { useTranslation } from "react-i18next";
  import { getData } from 'country-list';
  import UploadFileIcon from '@mui/icons-material/UploadFile';
  
  interface PaymentRequestData {
    id: string;
    type: string;
    internalRef: string;
    params: {
      currency: string;
      amount?: number;
      euroAmount?: number;
      expiresAt: string;
      internalRef: string;
    };
    expiresAt: string;
    ulid: string;
    dateLastUpdated: string;
    project: {
      physicalPayment: {
        logo: string;
        logoInverse: string;
        name: string;
        description: string;
        address: string;
        phone: string;
        email: string;
        backgroundColor: string;
        fontColor: string;
      };
      webhookUrl: string;
      network: string;
      blockchain: string;
      gasStation: Record<string, any>;
    };
  }
  
  const CustomerFields = ({ paymentData, formData, setFormData, showErrors }) => {
    const { t } = useTranslation();
    const countries = getData().map(country => ({
      id: country.code,
      name: country.name
    }));
    countries.push({ id: "other", name: "Other" });
  
    const isValidEmail = (email) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };
  
    if (!paymentData.params.euroAmount || paymentData.params.euroAmount < 1000) {
      return null;
    }
  
    return (
      <Card sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          Customer Information
        </Typography>
        
        <FormControl component="fieldset" margin="normal">
          <FormLabel component="legend">Customer Type</FormLabel>
          <RadioGroup
            value={formData.customerType}
            onChange={(e) => setFormData({ ...formData, customerType: e.target.value })}
            row
          >
            <FormControlLabel 
              value="individual" 
              control={<Radio />} 
              label="Individual" 
            />
            <FormControlLabel 
              value="company" 
              control={<Radio />} 
              label="Company" 
            />
          </RadioGroup>
          {showErrors && !formData.customerType && (
            <FormHelperText error>Please select a customer type</FormHelperText>
          )}
        </FormControl>
  
        {formData.customerType && (
          <>
            
  
            {formData.customerType === 'individual' ? (
              <>
              <TextField
              required
              fullWidth
              margin="normal"
              label="Email"
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              error={showErrors && (!formData.email || !isValidEmail(formData.email))}
              helperText={
                showErrors && 
                (!formData.email 
                  ? "Email is required" 
                  : !isValidEmail(formData.email) 
                    ? "Please enter a valid email address" 
                    : "")
              }
            />
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    fullWidth
                    margin="normal"
                    label="First Name"
                    value={formData.firstName}
                    onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
                    error={showErrors && !formData.firstName}
                    helperText={showErrors && !formData.firstName ? "First name is required" : ""}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    fullWidth
                    margin="normal"
                    label="Last Name"
                    value={formData.lastName}
                    onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
                    error={showErrors && !formData.lastName}
                    helperText={showErrors && !formData.lastName ? "Last name is required" : ""}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth margin="normal" error={showErrors && !formData.nationality}>
                    <InputLabel>Nationality</InputLabel>
                    <Select
                      value={formData.nationality}
                      onChange={(e) => setFormData({ ...formData, nationality: e.target.value })}
                      label="Nationality"
                    >
                      {countries.map((country) => (
                        <MenuItem key={country.id} value={country.id}>
                          {country.name}
                        </MenuItem>
                      ))}
                    </Select>
                    {showErrors && !formData.nationality && (
                      <FormHelperText>Nationality is required</FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    fullWidth
                    margin="normal"
                    label="Birth Date"
                    type="date"
                    value={formData.birthDate}
                    onChange={(e) => setFormData({ ...formData, birthDate: e.target.value })}
                    error={showErrors && !formData.birthDate}
                    helperText={showErrors && !formData.birthDate ? "Birth date is required" : ""}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
              </Grid>
              </>
            ) : (
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    fullWidth
                    margin="normal"
                    label="Company Name"
                    value={formData.companyName}
                    onChange={(e) => setFormData({ ...formData, companyName: e.target.value })}
                    error={showErrors && !formData.companyName}
                    helperText={showErrors && !formData.companyName ? "Company name is required" : ""}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    fullWidth
                    margin="normal"
                    label="Email"
                    type="email"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    error={showErrors && (!formData.email || !isValidEmail(formData.email))}
                    helperText={
                      showErrors && 
                      (!formData.email 
                        ? "Email is required" 
                        : !isValidEmail(formData.email) 
                          ? "Please enter a valid email address" 
                          : "")
                    }
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    required
                    fullWidth
                    margin="normal"
                    label="Company Address"
                    value={formData.companyAddress}
                    onChange={(e) => setFormData({ ...formData, companyAddress: e.target.value })}
                    error={showErrors && !formData.companyAddress}
                    helperText={showErrors && !formData.companyAddress ? "Company address is required" : ""}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth margin="normal" error={showErrors && !formData.companyCountry}>
                    <InputLabel>Company Country</InputLabel>
                    <Select
                      value={formData.companyCountry}
                      onChange={(e) => setFormData({ ...formData, companyCountry: e.target.value })}
                      label="Company Country"
                    >
                      {countries.map((country) => (
                        <MenuItem key={country.id} value={country.id}>
                          {country.name}
                        </MenuItem>
                      ))}
                    </Select>
                    {showErrors && !formData.companyCountry && (
                      <FormHelperText>Company country is required</FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    margin="normal"
                    label="VAT Number"
                    value={formData.companyVatNumber}
                    onChange={(e) => setFormData({ ...formData, companyVatNumber: e.target.value })}
                  />
                </Grid>
              </Grid>
            )}
          </>
        )}
      </Card>
    );
  };
  
  const DocumentFields = ({ formData, setFormData, showErrors }) => {
    return (
      <Box sx={{ mt: 3 }}>
        <Typography variant="h6" gutterBottom>
          Required Documents
        </Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          For payments above 1000€, we need to verify your identity and the source of funds.
        </Typography>

        <Grid container spacing={3}>
          {/* Document d'identité */}
          <Grid item xs={12} md={6}>
            <Card sx={{ 
              p: 2, 
              height: '100%',
              display: 'flex',
              flexDirection: 'column'
            }}>
              <Box>
                <Typography variant="subtitle1" gutterBottom>
                  Identity Document *
                </Typography>
                <Typography variant="body2" color="text.secondary" paragraph>
                  Please provide one of the following:
                </Typography>
                <ul style={{ margin: 0, paddingLeft: '20px', color: 'text.secondary', marginBottom: '16px' }}>
                  <li>ID Card</li>
                  <li>Passport</li>
                  <li>Driver's License</li>
                  <li>Residence Permit</li>
                </ul>
              </Box>
              <Box sx={{ mt: 'auto', pt: 2 }}>
                <Button
                  component="label"
                  variant="outlined"
                  startIcon={<UploadFileIcon />}
                  sx={{
                    width: '100%',
                    height: '40px',
                    borderStyle: 'dashed',
                    borderWidth: '1px',
                    '&:hover': {
                      borderStyle: 'dashed',
                      borderWidth: '1px',
                      backgroundColor: 'action.hover'
                    }
                  }}
                >
                  {formData.identityDocument ? formData.identityDocument.name : 'Choose Identity Document'}
                  <input
                    type="file"
                    hidden
                    accept="image/*,application/pdf"
                    onChange={(e) => {
                      setFormData({ ...formData, identityDocument: e.target.files?.[0] });
                    }}
                    required
                  />
                </Button>
                {showErrors && !formData.identityDocument && (
                  <Typography color="error" display="block" sx={{ mt: 1, fontWeight: 'bold' }}>
                    Identity document is required
                  </Typography>
                )}
              </Box>
            </Card>
          </Grid>

          {/* Justificatif */}
          <Grid item xs={12} md={6}>
            <Card sx={{ 
              p: 2, 
              height: '100%',
              display: 'flex',
              flexDirection: 'column'
            }}>
              <Box>
                <Typography variant="subtitle1" gutterBottom>
                  Proof of Identity *
                </Typography>
                <Typography variant="body2" color="text.secondary" paragraph>
                  Please provide one of the following:
                </Typography>
                <ul style={{ margin: 0, paddingLeft: '20px', color: 'text.secondary', marginBottom: '16px' }}>
                  <li>Invoice</li>
                  <li>Company Registration Document (KBIS, Certificate of Incorporation)</li>
                  <li>Proof of Funds Source</li>
                  <li>Bank Statement</li>
                </ul>
              </Box>
              <Box sx={{ mt: 'auto', pt: 2 }}>
                <Button
                  component="label"
                  variant="outlined"
                  startIcon={<UploadFileIcon />}
                  sx={{
                    width: '100%',
                    height: '40px',
                    borderStyle: 'dashed',
                    borderWidth: '1px',
                    '&:hover': {
                      borderStyle: 'dashed',
                      borderWidth: '1px',
                      backgroundColor: 'action.hover'
                    }
                  }}
                >
                  {formData.proofDocument ? formData.proofDocument.name : 'Choose Proof Document'}
                  <input
                    type="file"
                    hidden
                    accept="image/*,application/pdf"
                    onChange={(e) => {
                      setFormData({ ...formData, proofDocument: e.target.files?.[0] });
                    }}
                    required
                  />
                </Button>
                {showErrors && !formData.proofDocument && (
                  <Typography color="error" display="block" sx={{ mt: 1, fontWeight: 'bold' }}>
                    Proof document is required
                  </Typography>
                )}
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Box>
    );
  };
  
  // The payer is only sent on to an https page of a Coinhouse domain, whatever the API returns.
  const isCoinhousePaymentUrl = (value: unknown): value is string => {
    if (typeof value !== "string") return false;
    try {
      const url = new URL(value);
      return url.protocol === "https:" && (url.hostname === "coinhouse.io" || url.hostname.endsWith(".coinhouse.io"));
    } catch {
      return false;
    }
  };

  const PaymentRequest = () => {
    const theme = useTheme();
    const { id } = useParams<{ id: string }>();
    const [loading, setLoading] = useState(true);
    const [processingPayment, setProcessingPayment] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [paymentData, setPaymentData] = useState<PaymentRequestData | null>(null);
    const [showPaymentForm, setShowPaymentForm] = useState(false);
    const [formData, setFormData] = useState({
      customerType: '',
      email: '',
      firstName: '',
      lastName: '',
      nationality: '',
      birthDate: '',
      companyName: '',
      companyAddress: '',
      companyCountry: '',
      companyVatNumber: '',
      identityDocument: null,
      proofDocument: null,
      selectedCurrency: ''
    });
    const [showErrors, setShowErrors] = useState(false);
  
    const getTimeRemaining = (expiresAt: string) => {
      const now = new Date().getTime();
      const expiry = new Date(expiresAt).getTime();
      const timeLeft = expiry - now;
  
      if (timeLeft <= 0) return "Expired";
  
      const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
  
      return `${days}d ${hours}h ${minutes}m`;
    };
  
    useEffect(() => {
      if (!id) return;
      const url = new URL(`${BASE_API_URL}/paymentLinks/payment-request/${id}`);
      fetchUtils
        .fetchJson(url.toString())
        .then((response) => {
          setPaymentData(response.json);
          setLoading(false);
        })
        .catch((err) => {
          if (err.status === 410) {
            setError("This payment link has expired.");
          } else {
            setError("This payment link is invalid or has expired.");
          }
          setLoading(false);
        });
    }, [id]);
  
    // A link past its expiry date is refused by the API when activated: it is shown as such.
    const isExpired = Boolean(paymentData?.expiresAt) && new Date(paymentData.expiresAt).getTime() <= Date.now();

    const handlePayClick = () => {
      if (paymentData?.params.euroAmount >= 1000) {
        setShowPaymentForm(true);
      } else {
        handlePayment();
      }
    };
  
    const convertFileToBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    };
  
    const handleSubmit = async () => {
      try {
        let payload = {};

        // Si le montant est >= 1000€, on traite les documents
        if (paymentData.params.euroAmount >= 1000) {
          if (formData.identityDocument && formData.proofDocument) {
            const documentOrder = [
              {
                src: await convertFileToBase64(formData.identityDocument),
                title: formData.identityDocument.name,
                type: "identity"
              },
              {
                src: await convertFileToBase64(formData.proofDocument),
                title: formData.proofDocument.name,
                type: "proof"
              }
            ];

            const customer = {
              email: formData.email,
              type: formData.customerType,
              ...(formData.customerType === 'individual' 
                ? {
                    firstname: formData.firstName,
                    lastname: formData.lastName,
                    nationality: formData.nationality,
                    birthDate: formData.birthDate
                  }
                : {
                    companyName: formData.companyName,
                    companyAddress: formData.companyAddress,
                    companyCountry: formData.companyCountry,
                    companyVatNumber: formData.companyVatNumber
                  }
              )
            };

            payload = {
              customer,
              documentOrder
            };
          }
        }

        // Ajout de la devise sélectionnée si customer_choice
        if (paymentData.params.currency === 'customer_choice' && formData.selectedCurrency) {
          payload = {
            ...payload,
            selectedCurrency: formData.selectedCurrency
          };
        }

        const response = await fetch(`${BASE_API_URL}/paymentLinks/${id}/activate`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload)
        });

        const data = await response.json();
        
        if (isCoinhousePaymentUrl(data.urlPayment)) {
          window.location.href = data.urlPayment;
        }
        else {
          setError(typeof data?.message === "string" && data.message ? data.message : "An error occurred while processing the payment");
          setProcessingPayment(false);
          setShowPaymentForm(false);
        }
      } catch (error) {
        console.error('Error in handleSubmit:', error);
        setError("An error occurred while processing the payment");
        setProcessingPayment(false);
        setShowPaymentForm(false);
      }
    };
  
    const handlePayment = async () => {
      if (!paymentData) {
        console.log('No payment data');
        return;
      }
      
      // Vérification de la devise si customer_choice
      if (paymentData.params.currency === 'customer_choice' && !formData.selectedCurrency) {
        setError("Please select a currency");
        return;
      }
      
      if (paymentData.params.euroAmount >= 1000) {
        if (!formData.customerType) {
          setError("Please select a customer type");
          return;
        }
        if (!formData.identityDocument || !formData.proofDocument) {
          setError("Please upload both identity document and proof document");
          return;
        }
        if (formData.customerType === 'individual') {
          if (!formData.firstName || !formData.lastName || !formData.nationality || !formData.birthDate) {
            setError("Please fill all required fields");
            return;
          }
        } else if (formData.customerType === 'company') {
          if (!formData.companyName || !formData.companyAddress || !formData.companyCountry) {
            setError("Please fill all required fields");
            return;
          }
        }
      }
      
      setProcessingPayment(true);
      try {
        await handleSubmit();
      } catch (err: any) {
        console.error('Error in handlePayment:', err);
        setError(err?.body?.message || "An error occurred while processing the payment");
        setProcessingPayment(false);
      }
    };
  
    const handleContinuePayment = () => {
      setShowErrors(true);
      
      // Vérification de la devise si customer_choice
      if (paymentData.params.currency === 'customer_choice' && !formData.selectedCurrency) {
        return;
      }
      
      // Validation des champs
      if (paymentData.params.euroAmount >= 1000) {
        if (!formData.customerType) return;
        if (!formData.identityDocument || !formData.proofDocument) return;
        
        if (formData.customerType === 'individual') {
          if (!formData.firstName || !formData.lastName || !formData.nationality || !formData.birthDate) return;
        } else if (formData.customerType === 'company') {
          if (!formData.companyName || !formData.companyAddress || !formData.companyCountry) return;
        }
      }

      setShowPaymentForm(false);
      handlePayment();
    };
  
    return (
      <>
        <Helmet>
          <title>Coinhouse Solutions - Payment Request</title>
        </Helmet>
  
        <Container maxWidth="md">
          {loading && (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
              <CircularProgress size={60} />
            </Box>
          )}
  
          {!loading && error && (
            <Box sx={{ mt: 4 }}>
              <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
            </Box>
          )}
  
          {!loading && paymentData && (
            <Box sx={{ py: 4 }}>
              <Paper 
                elevation={3} 
                sx={{ 
                  p: 4, 
                  mb: 4, 
                  borderRadius: 2
                }}
              >
                <Grid container spacing={3} alignItems="center">
                  <Grid item xs={12} md={4} sx={{ textAlign: 'center' }}>
                    {paymentData.project.physicalPayment.logo && (
                      <img 
                        src={paymentData.project.physicalPayment.logo} 
                        alt={paymentData.project.physicalPayment.name}
                        style={{ 
                          maxWidth: '200px',
                          maxHeight: '100px',
                          objectFit: 'contain'
                        }}
                      />
                    )}
                  </Grid>
                  <Grid item xs={12} md={8}>
                    <Typography variant="h4" gutterBottom>
                      {paymentData.project.physicalPayment.name}
                    </Typography>
                    <Typography variant="body1">
                      {paymentData.project.physicalPayment.description}
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
  
              <Paper 
                elevation={1} 
                sx={{ 
                  p: 3, 
                  mb: 4, 
                  borderRadius: 2,
                  bgcolor: 'background.default',
                  border: '1px solid',
                  borderColor: 'divider'
                }}
              >
                <Typography variant="body1" color="text.secondary" paragraph>
                  <strong>{paymentData.project.physicalPayment.name}</strong> has generated this payment link to allow you to complete your transaction securely. 
                  This link is unique and temporary, valid until {new Date(paymentData.expiresAt).toLocaleDateString("en-GB")}.
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  The payment will be processed securely through our platform. You can proceed with the payment by clicking the "Pay Now" button.
                </Typography>
              </Paper>
  
              <Grid container spacing={3}>
                <Grid item xs={12} md={8}>
                  <Card sx={{ p: 3, mb: 3 }}>
                    <Typography variant="h5" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <PaymentIcon /> Payment Details
                    </Typography>
                    <Divider sx={{ my: 2 }} />
                    
                    <Box sx={{ mb: 3 }}>
                      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                        Amount to pay
                      </Typography>
                      <Typography variant="h3" color="primary" gutterBottom>
                        {paymentData.params.euroAmount} EUR
                      </Typography>
                      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                        Payment currency
                      </Typography>
                      {paymentData.params.currency === 'customer_choice' ? (
                        <Box>
                          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                            Please select your preferred cryptocurrency for this payment:
                          </Typography>
                          <FormControl fullWidth margin="normal" error={showErrors && !formData.selectedCurrency}>
                            <InputLabel>Select Currency</InputLabel>
                            <Select
                              value={formData.selectedCurrency}
                              onChange={(e) => setFormData({ ...formData, selectedCurrency: e.target.value })}
                              label="Select Currency"
                            >
                              <MenuItem value="usdc">
                                <Box>
                                  <Typography variant="body1">USDC</Typography>

                                </Box>
                              </MenuItem>
                              <MenuItem value="eth">
                                <Box>
                                  <Typography variant="body1">ETH</Typography>

                                </Box>
                              </MenuItem>
                            </Select>
                            {showErrors && !formData.selectedCurrency && (
                              <FormHelperText>Please select a currency to proceed with the payment</FormHelperText>
                            )}
                          </FormControl>
                          <Typography color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                            Both currencies are supported on the Ethereum network. The final amount will be calculated at the time of payment based on current exchange rates.
                          </Typography>
                        </Box>
                      ) : (
                        <Chip 
                          label={paymentData.params.currency.toUpperCase()} 
                          color="primary" 
                          variant="outlined"
                        />
                      )}
                    </Box>
  
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Reference
                        </Typography>
                        <Typography variant="body1">
                          {paymentData.params.internalRef}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Payment ID
                        </Typography>
                        <Typography variant="body1">
                          {paymentData.ulid}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Card>
  
                  <Card sx={{ p: 3 }}>
                    <Typography variant="h5" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <BusinessIcon /> Merchant Information
                    </Typography>
                    <Divider sx={{ my: 2 }} />
                    
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Address
                        </Typography>
                        <Typography variant="body1">
                          {paymentData.project.physicalPayment.address}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Phone
                        </Typography>
                        <Typography variant="body1">
                          {paymentData.project.physicalPayment.phone}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="subtitle2" color="text.secondary">
                          Email
                        </Typography>
                        <Typography variant="body1">
                          {paymentData.project.physicalPayment.email}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
  
                <Grid item xs={12} md={4}>
                  <Card sx={{ p: 3, position: 'sticky', top: 20 }}>
                    <Typography variant="h5" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <AccessTimeIcon /> Time Remaining
                    </Typography>
                    <Divider sx={{ my: 2 }} />
                    
                    <Typography variant="h4" color="primary" gutterBottom>
                      {getTimeRemaining(paymentData.expiresAt)}
                    </Typography>
                    
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                      {isExpired ? "Expired on" : "Expires on"} {new Date(paymentData.expiresAt).toLocaleDateString("en-GB")}
                    </Typography>

                    {isExpired ? (
                      <Alert severity="warning">
                        This payment link can no longer be paid. Please contact{" "}
                        {paymentData.project?.physicalPayment?.name || "the merchant"} for a new link.
                      </Alert>
                    ) : (
                      <Button
                        fullWidth
                        variant="contained"
                        size="large"
                        onClick={handlePayClick}
                        disabled={processingPayment}
                        sx={{ mt: 2 }}
                      >
                        {processingPayment ? 'Processing Payment...' : 'Pay Now'}
                      </Button>
                    )}
                  </Card>
                </Grid>
              </Grid>

              <Box 
                sx={{ 
                  mt: 4, 
                  p: 3, 
                  bgcolor: 'black', 
                  borderRadius: 2,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 2
                }}
              >
                <Link 
                  href="https://www.coinhouse.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  sx={{ 
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    textDecoration: 'none',
                    '&:hover': {
                      opacity: 0.8
                    }
                  }}
                >
                  <img 
                    src="/static/images/logos/coinhouse.png" 
                    alt="Coinhouse" 
                    style={{ 
                      height: '24px',
                      width: 'auto'
                    }}
                  />
                  <Typography variant="body1" sx={{ color: 'white' }}>
                    Secure payment processed by Coinhouse
                  </Typography>
                </Link>
              </Box>
            </Box>
          )}
        </Container>
  
        <Dialog
          open={showPaymentForm}
          onClose={() => {
            setShowPaymentForm(false);
            setShowErrors(false);
          }}
          maxWidth="md"
          fullWidth
        >
          <Box sx={{ p: 3 }}>
            <Typography variant="h5" gutterBottom>
              Additional Information Required
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              For payments above 1000€, we need some additional information to process your payment.
            </Typography>
            
            <CustomerFields 
              paymentData={paymentData} 
              formData={formData} 
              setFormData={setFormData}
              showErrors={showErrors}
            />

            <DocumentFields 
              formData={formData} 
              setFormData={setFormData}
              showErrors={showErrors}
            />

            <Divider sx={{ my: 3 }} />

            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'flex-end', 
              gap: 2,
              mt: 3
            }}>
              <Button
                variant="outlined"
                onClick={() => {
                  setShowPaymentForm(false);
                  setShowErrors(false);
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleContinuePayment}
              >
                Continue to Payment
              </Button>
            </Box>
          </Box>
        </Dialog>

        <Dialog
          open={processingPayment}
          PaperProps={{
            sx: {
              backgroundColor: 'transparent',
              boxShadow: 'none',
            },
          }}
        >
          <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            p: 3,
            bgcolor: 'rgba(0, 0, 0, 0.8)',
            borderRadius: 2
          }}>
            <CircularProgress size={60} />
            <Typography variant="h6" sx={{ mt: 2, color: 'white' }}>
              Processing your payment...
            </Typography>
            <Typography variant="body2" sx={{ mt: 1, color: 'white' }}>
              Please do not close this window
            </Typography>
          </Box>
        </Dialog>
      </>
    );
  };
  
  export default PaymentRequest;
  